export function mwCanExchange(originalMwRank, newMwRank) {
  if (!originalMwRank || !newMwRank) return null; // indeterminate
  // a is the highest, then b then c. So we can just compare the character lexicographically
  return originalMwRank <= newMwRank;
}
